import { GetStaticPropsContext } from 'next';
import { HelpCenter } from 'components/features/help/help-center';

const HelpPage = () => {
  return <HelpCenter />;
};

export async function getStaticProps({
  locale
}: GetStaticPropsContext<any, any>) {
  return {
    props: {
      messages: {
        help: { ...require(`../../i18n/pages/help/${locale}.json`) },
        shared: { ...require(`../../i18n/shared/${locale}.json`) },
        dashboard: { ...require(`../../i18n/pages/dashboard/${locale}.json`) }
      }
    }
  };
}

export default HelpPage;
